import { render, staticRenderFns } from "./Trend.vue?vue&type=template&id=2de17702&scoped=true&"
import script from "./Trend.vue?vue&type=script&lang=js&"
export * from "./Trend.vue?vue&type=script&lang=js&"
import style0 from "./Trend.vue?vue&type=style&index=0&id=2de17702&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de17702",
  null
  
)

/* custom blocks */
import block0 from "./Trend.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports